import React from "react";
import { ShieldCheck, Sparkles, HeartHandshake, BookOpen } from "lucide-react";
import { MEDIA } from "../../lib/constants";

const POINTS = [
  { icon: ShieldCheck, title: "Licensed & compliant DC dispensary", copy: "Regulated by the DC Office of Cannabis Administration. Every product is lab-tested and batch-traced." },
  { icon: Sparkles, title: "High-quality curated products", copy: "We reject more than we accept. Only cultivators and processors we'd trust for our own families make the shelf." },
  { icon: HeartHandshake, title: "Knowledgeable, unpushy staff", copy: "Ask anything. We'll match you with what actually works — never the highest-margin bag." },
  { icon: BookOpen, title: "Wellness & education first", copy: "Clear dosing guidance, honest effects, and education for new patients and seasoned ones alike." },
];

export const TrustAuthority = () => {
  return (
    <section className="py-24 sm:py-32 bg-white" data-testid="trust-authority">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="relative overflow-hidden border border-black/10">
            <img src={MEDIA.salesFloor2} alt="District Wellness Center dispensary interior — sales counter and product displays" className="w-full h-[500px] object-cover" />
          </div>
          <div className="mt-6 border border-black/10 p-6 bg-[#FAFAFA]">
            <div className="flex items-baseline gap-4">
              <div className="font-serif text-brand text-5xl leading-none">500+</div>
              <div className="text-sm text-ink-muted">premium products curated across flower, vapes, edibles & concentrates.</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Why DWC</div>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
            Why patients trust<br/><em className="text-brand">District Wellness Center</em>.
          </h2>

          <div className="mt-12 space-y-8">
            {POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div key={p.title} className="grid grid-cols-12 gap-5 group" data-testid={`trust-point-${i}`}>
                  <div className="col-span-1 pt-1"><Icon size={22} className="text-brand" /></div>
                  <div className="col-span-11 border-b border-black/10 pb-7">
                    <div className="flex items-start justify-between gap-6">
                      <h3 className="font-serif text-2xl leading-tight">{p.title}</h3>
                      <span className="text-[10px] uppercase tracking-[0.3em] text-ink-muted mt-2">0{i+1}</span>
                    </div>
                    <p className="mt-3 text-base text-ink-muted leading-relaxed max-w-2xl">{p.copy}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustAuthority;
